/**
 * @fileoverview gRPC-Web generated client stub for com.mu.routing.proto
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


import * as grpcWeb from 'grpc-web';

import {
  ClientPointRequest,
  CreateDistributionMassiveRequest,
  CreateDistributionMassiveResponse,
  CreateMassiveDeliveryNewRequest,
  CreateMassiveDeliveryNewResponse,
  CreateMassiveDeliveryRequest,
  CreateMassiveDeliveryResponse,
  CreateStatusDistributionCenterResponse,
  DistributionRequest,
  DistributionResponse,
  GetFileSignedUrlRequest,
  GetFileSignedUrlResponse,
  GetMassiveDeliveryRequest,
  GetMassiveDeliveryResponse,
  GetRoutingRequest,
  GetRoutingResponse,
  ListCitiesNewRequest,
  ListCitiesRequest,
  ListCitiesResponse,
  ListCountriesRequest,
  ListCountriesResponse,
  ListDeliveryPackageSizeRequest,
  ListDeliveryPackageSizeResponse,
  ListDistributionCenterRequest,
  ListDistributionCenterResponse,
  ListLocalitiesRequest,
  ListLocalitiesResponse,
  ListMassiveDeliverCompaniesNewRequest,
  ListMassiveDeliverCompaniesRequest,
  ListMassiveDeliverCompaniesResponse,
  ListMassiveDeliveryNewRequest,
  ListMassiveDeliveryNewResponse,
  ListMassiveDeliveryRequest,
  ListMassiveDeliveryResponse,
  ListMassiveDeliveryServiceCoordsRequest,
  ListMassiveDeliveryServiceCoordsResponse,
  ListMassiveDeliveryServiceRequest,
  ListMassiveDeliveryServiceResponse,
  ListRoutingServicesRequest,
  ListRoutingServicesResponse,
  ListRoutingVehiclesRequest,
  ListRoutingVehiclesResponse,
  ListZonesRequest,
  ListZonesResponse,
  ListenRequest,
  ListenResponse,
  ProgramDeliveryRequest,
  ProgramDeliveryResponse,
  RouteNewRequest,
  RouteRequest,
  RouteResponse,
  UpdateMassiveDeliveryServiceNewRequest,
  UpdateMassiveDeliveryServiceNewResponse,
  UpdateMassiveDeliveryServiceRequest,
  UpdateMassiveDeliveryServiceResponse,
  UpdateVehicleOrderRequest,
  UpdateVehicleOrderResponse} from './routing_pb';

export class RoutingServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials: null | { [index: string]: string; },
               options: null | { [index: string]: string; }) {
    if (!options) options = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

}

export class CompanyServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials: null | { [index: string]: string; },
               options: null | { [index: string]: string; }) {
    if (!options) options = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoListMassiveDeliverCompanies = new grpcWeb.AbstractClientBase.MethodInfo(
    ListMassiveDeliverCompaniesResponse,
    (request: ListMassiveDeliverCompaniesRequest) => {
      return request.serializeBinary();
    },
    ListMassiveDeliverCompaniesResponse.deserializeBinary
  );

  listMassiveDeliverCompanies(
    request: ListMassiveDeliverCompaniesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: ListMassiveDeliverCompaniesResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.CompanyService/ListMassiveDeliverCompanies',
      request,
      metadata || {},
      this.methodInfoListMassiveDeliverCompanies,
      callback);
  }

}

export class CompanyServiceNewClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials: null | { [index: string]: string; },
               options: null | { [index: string]: string; }) {
    if (!options) options = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoListMassiveDeliverCompanies = new grpcWeb.AbstractClientBase.MethodInfo(
    ListMassiveDeliverCompaniesResponse,
    (request: ListMassiveDeliverCompaniesNewRequest) => {
      return request.serializeBinary();
    },
    ListMassiveDeliverCompaniesResponse.deserializeBinary
  );

  listMassiveDeliverCompanies(
    request: ListMassiveDeliverCompaniesNewRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: ListMassiveDeliverCompaniesResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.CompanyServiceNew/ListMassiveDeliverCompanies',
      request,
      metadata || {},
      this.methodInfoListMassiveDeliverCompanies,
      callback);
  }

}

export class CityServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials: null | { [index: string]: string; },
               options: null | { [index: string]: string; }) {
    if (!options) options = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoListCities = new grpcWeb.AbstractClientBase.MethodInfo(
    ListCitiesResponse,
    (request: ListCitiesRequest) => {
      return request.serializeBinary();
    },
    ListCitiesResponse.deserializeBinary
  );

  listCities(
    request: ListCitiesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: ListCitiesResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.CityService/ListCities',
      request,
      metadata || {},
      this.methodInfoListCities,
      callback);
  }

}

export class CityServiceNewClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials: null | { [index: string]: string; },
               options: null | { [index: string]: string; }) {
    if (!options) options = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoListCities = new grpcWeb.AbstractClientBase.MethodInfo(
    ListCitiesResponse,
    (request: ListCitiesNewRequest) => {
      return request.serializeBinary();
    },
    ListCitiesResponse.deserializeBinary
  );

  listCities(
    request: ListCitiesNewRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: ListCitiesResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.CityServiceNew/ListCities',
      request,
      metadata || {},
      this.methodInfoListCities,
      callback);
  }

}

export class ClientPointServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials: null | { [index: string]: string; },
               options: null | { [index: string]: string; }) {
    if (!options) options = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoListDistributionCenter = new grpcWeb.AbstractClientBase.MethodInfo(
    ListDistributionCenterResponse,
    (request: ListDistributionCenterRequest) => {
      return request.serializeBinary();
    },
    ListDistributionCenterResponse.deserializeBinary
  );

  listDistributionCenter(
    request: ListDistributionCenterRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: ListDistributionCenterResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.ClientPointService/ListDistributionCenter',
      request,
      metadata || {},
      this.methodInfoListDistributionCenter,
      callback);
  }

  methodInfoCreateDistributionCenter = new grpcWeb.AbstractClientBase.MethodInfo(
    CreateStatusDistributionCenterResponse,
    (request: ClientPointRequest) => {
      return request.serializeBinary();
    },
    CreateStatusDistributionCenterResponse.deserializeBinary
  );

  createDistributionCenter(
    request: ClientPointRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: CreateStatusDistributionCenterResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.ClientPointService/CreateDistributionCenter',
      request,
      metadata || {},
      this.methodInfoCreateDistributionCenter,
      callback);
  }

  methodInfoDeleteDistributionCenter = new grpcWeb.AbstractClientBase.MethodInfo(
    DistributionResponse,
    (request: DistributionRequest) => {
      return request.serializeBinary();
    },
    DistributionResponse.deserializeBinary
  );

  deleteDistributionCenter(
    request: DistributionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: DistributionResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.ClientPointService/DeleteDistributionCenter',
      request,
      metadata || {},
      this.methodInfoDeleteDistributionCenter,
      callback);
  }

  methodInfoCreateDistributionCenterMassive = new grpcWeb.AbstractClientBase.MethodInfo(
    CreateDistributionMassiveResponse,
    (request: CreateDistributionMassiveRequest) => {
      return request.serializeBinary();
    },
    CreateDistributionMassiveResponse.deserializeBinary
  );

  createDistributionCenterMassive(
    request: CreateDistributionMassiveRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: CreateDistributionMassiveResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.ClientPointService/CreateDistributionCenterMassive',
      request,
      metadata || {},
      this.methodInfoCreateDistributionCenterMassive,
      callback);
  }

  methodInfoUpdateDistributionCenter = new grpcWeb.AbstractClientBase.MethodInfo(
    DistributionResponse,
    (request: ClientPointRequest) => {
      return request.serializeBinary();
    },
    DistributionResponse.deserializeBinary
  );

  updateDistributionCenter(
    request: ClientPointRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: DistributionResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.ClientPointService/UpdateDistributionCenter',
      request,
      metadata || {},
      this.methodInfoUpdateDistributionCenter,
      callback);
  }

}

export class MassiveDeliveryServiceNewClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials: null | { [index: string]: string; },
               options: null | { [index: string]: string; }) {
    if (!options) options = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoListMassiveDeliveryService = new grpcWeb.AbstractClientBase.MethodInfo(
    ListMassiveDeliveryNewResponse,
    (request: ListMassiveDeliveryNewRequest) => {
      return request.serializeBinary();
    },
    ListMassiveDeliveryNewResponse.deserializeBinary
  );

  listMassiveDeliveryService(
    request: ListMassiveDeliveryNewRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: ListMassiveDeliveryNewResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.MassiveDeliveryServiceNew/ListMassiveDeliveryService',
      request,
      metadata || {},
      this.methodInfoListMassiveDeliveryService,
      callback);
  }

  methodInfoCreateMassiveDelivery = new grpcWeb.AbstractClientBase.MethodInfo(
    CreateMassiveDeliveryNewResponse,
    (request: CreateMassiveDeliveryNewRequest) => {
      return request.serializeBinary();
    },
    CreateMassiveDeliveryNewResponse.deserializeBinary
  );

  createMassiveDelivery(
    request: CreateMassiveDeliveryNewRequest,
    metadata?: grpcWeb.Metadata) {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/com.mu.routing.proto.MassiveDeliveryServiceNew/CreateMassiveDelivery',
      request,
      metadata || {},
      this.methodInfoCreateMassiveDelivery);
  }

  methodInfoRoute = new grpcWeb.AbstractClientBase.MethodInfo(
    RouteResponse,
    (request: RouteNewRequest) => {
      return request.serializeBinary();
    },
    RouteResponse.deserializeBinary
  );

  route(
    request: RouteNewRequest,
    metadata?: grpcWeb.Metadata) {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/com.mu.routing.proto.MassiveDeliveryServiceNew/Route',
      request,
      metadata || {},
      this.methodInfoRoute);
  }

  methodInfoUpdateMassiveDeliveryService = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdateMassiveDeliveryServiceNewResponse,
    (request: UpdateMassiveDeliveryServiceNewRequest) => {
      return request.serializeBinary();
    },
    UpdateMassiveDeliveryServiceNewResponse.deserializeBinary
  );

  updateMassiveDeliveryService(
    request: UpdateMassiveDeliveryServiceNewRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdateMassiveDeliveryServiceNewResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.MassiveDeliveryServiceNew/UpdateMassiveDeliveryService',
      request,
      metadata || {},
      this.methodInfoUpdateMassiveDeliveryService,
      callback);
  }

  methodInfoListDeliveryPackageSize = new grpcWeb.AbstractClientBase.MethodInfo(
    ListDeliveryPackageSizeResponse,
    (request: ListDeliveryPackageSizeRequest) => {
      return request.serializeBinary();
    },
    ListDeliveryPackageSizeResponse.deserializeBinary
  );

  listDeliveryPackageSize(
    request: ListDeliveryPackageSizeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: ListDeliveryPackageSizeResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.MassiveDeliveryServiceNew/ListDeliveryPackageSize',
      request,
      metadata || {},
      this.methodInfoListDeliveryPackageSize,
      callback);
  }

  methodInfoListLocalities = new grpcWeb.AbstractClientBase.MethodInfo(
    ListLocalitiesResponse,
    (request: ListLocalitiesRequest) => {
      return request.serializeBinary();
    },
    ListLocalitiesResponse.deserializeBinary
  );

  listLocalities(
    request: ListLocalitiesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: ListLocalitiesResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.MassiveDeliveryServiceNew/ListLocalities',
      request,
      metadata || {},
      this.methodInfoListLocalities,
      callback);
  }

}

export class MassiveDeliveryServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials: null | { [index: string]: string; },
               options: null | { [index: string]: string; }) {
    if (!options) options = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoCreateMassiveDelivery = new grpcWeb.AbstractClientBase.MethodInfo(
    CreateMassiveDeliveryResponse,
    (request: CreateMassiveDeliveryRequest) => {
      return request.serializeBinary();
    },
    CreateMassiveDeliveryResponse.deserializeBinary
  );

  createMassiveDelivery(
    request: CreateMassiveDeliveryRequest,
    metadata?: grpcWeb.Metadata) {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/com.mu.routing.proto.MassiveDeliveryService/CreateMassiveDelivery',
      request,
      metadata || {},
      this.methodInfoCreateMassiveDelivery);
  }

  methodInfoListMassiveDelivery = new grpcWeb.AbstractClientBase.MethodInfo(
    ListMassiveDeliveryResponse,
    (request: ListMassiveDeliveryRequest) => {
      return request.serializeBinary();
    },
    ListMassiveDeliveryResponse.deserializeBinary
  );

  listMassiveDelivery(
    request: ListMassiveDeliveryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: ListMassiveDeliveryResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.MassiveDeliveryService/ListMassiveDelivery',
      request,
      metadata || {},
      this.methodInfoListMassiveDelivery,
      callback);
  }

  methodInfogetMassiveDelivery = new grpcWeb.AbstractClientBase.MethodInfo(
    GetMassiveDeliveryResponse,
    (request: GetMassiveDeliveryRequest) => {
      return request.serializeBinary();
    },
    GetMassiveDeliveryResponse.deserializeBinary
  );

  getMassiveDelivery(
    request: GetMassiveDeliveryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetMassiveDeliveryResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.MassiveDeliveryService/getMassiveDelivery',
      request,
      metadata || {},
      this.methodInfogetMassiveDelivery,
      callback);
  }

  methodInfoListMassiveDeliveryService = new grpcWeb.AbstractClientBase.MethodInfo(
    ListMassiveDeliveryServiceResponse,
    (request: ListMassiveDeliveryServiceRequest) => {
      return request.serializeBinary();
    },
    ListMassiveDeliveryServiceResponse.deserializeBinary
  );

  listMassiveDeliveryService(
    request: ListMassiveDeliveryServiceRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: ListMassiveDeliveryServiceResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.MassiveDeliveryService/ListMassiveDeliveryService',
      request,
      metadata || {},
      this.methodInfoListMassiveDeliveryService,
      callback);
  }

  methodInfoListMassiveDeliveryServiceCoords = new grpcWeb.AbstractClientBase.MethodInfo(
    ListMassiveDeliveryServiceCoordsResponse,
    (request: ListMassiveDeliveryServiceCoordsRequest) => {
      return request.serializeBinary();
    },
    ListMassiveDeliveryServiceCoordsResponse.deserializeBinary
  );

  listMassiveDeliveryServiceCoords(
    request: ListMassiveDeliveryServiceCoordsRequest,
    metadata?: grpcWeb.Metadata) {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/com.mu.routing.proto.MassiveDeliveryService/ListMassiveDeliveryServiceCoords',
      request,
      metadata || {},
      this.methodInfoListMassiveDeliveryServiceCoords);
  }

  methodInfoUpdateMassiveDeliveryService = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdateMassiveDeliveryServiceResponse,
    (request: UpdateMassiveDeliveryServiceRequest) => {
      return request.serializeBinary();
    },
    UpdateMassiveDeliveryServiceResponse.deserializeBinary
  );

  updateMassiveDeliveryService(
    request: UpdateMassiveDeliveryServiceRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdateMassiveDeliveryServiceResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.MassiveDeliveryService/UpdateMassiveDeliveryService',
      request,
      metadata || {},
      this.methodInfoUpdateMassiveDeliveryService,
      callback);
  }

  methodInfoGetRouting = new grpcWeb.AbstractClientBase.MethodInfo(
    GetRoutingResponse,
    (request: GetRoutingRequest) => {
      return request.serializeBinary();
    },
    GetRoutingResponse.deserializeBinary
  );

  getRouting(
    request: GetRoutingRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetRoutingResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.MassiveDeliveryService/GetRouting',
      request,
      metadata || {},
      this.methodInfoGetRouting,
      callback);
  }

  methodInfoListRoutingVehicles = new grpcWeb.AbstractClientBase.MethodInfo(
    ListRoutingVehiclesResponse,
    (request: ListRoutingVehiclesRequest) => {
      return request.serializeBinary();
    },
    ListRoutingVehiclesResponse.deserializeBinary
  );

  listRoutingVehicles(
    request: ListRoutingVehiclesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: ListRoutingVehiclesResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.MassiveDeliveryService/ListRoutingVehicles',
      request,
      metadata || {},
      this.methodInfoListRoutingVehicles,
      callback);
  }

  methodInfoListRoutingServices = new grpcWeb.AbstractClientBase.MethodInfo(
    ListRoutingServicesResponse,
    (request: ListRoutingServicesRequest) => {
      return request.serializeBinary();
    },
    ListRoutingServicesResponse.deserializeBinary
  );

  listRoutingServices(
    request: ListRoutingServicesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: ListRoutingServicesResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.MassiveDeliveryService/ListRoutingServices',
      request,
      metadata || {},
      this.methodInfoListRoutingServices,
      callback);
  }

  methodInfoRoute = new grpcWeb.AbstractClientBase.MethodInfo(
    RouteResponse,
    (request: RouteRequest) => {
      return request.serializeBinary();
    },
    RouteResponse.deserializeBinary
  );

  route(
    request: RouteRequest,
    metadata?: grpcWeb.Metadata) {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/com.mu.routing.proto.MassiveDeliveryService/Route',
      request,
      metadata || {},
      this.methodInfoRoute);
  }

  methodInfoListen = new grpcWeb.AbstractClientBase.MethodInfo(
    ListenResponse,
    (request: ListenRequest) => {
      return request.serializeBinary();
    },
    ListenResponse.deserializeBinary
  );

  listen(
    request: ListenRequest,
    metadata?: grpcWeb.Metadata) {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/com.mu.routing.proto.MassiveDeliveryService/Listen',
      request,
      metadata || {},
      this.methodInfoListen);
  }

  methodInfoProgramDelivery = new grpcWeb.AbstractClientBase.MethodInfo(
    ProgramDeliveryResponse,
    (request: ProgramDeliveryRequest) => {
      return request.serializeBinary();
    },
    ProgramDeliveryResponse.deserializeBinary
  );

  programDelivery(
    request: ProgramDeliveryRequest,
    metadata?: grpcWeb.Metadata) {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/com.mu.routing.proto.MassiveDeliveryService/ProgramDelivery',
      request,
      metadata || {},
      this.methodInfoProgramDelivery);
  }

  methodInfoListZones = new grpcWeb.AbstractClientBase.MethodInfo(
    ListZonesResponse,
    (request: ListZonesRequest) => {
      return request.serializeBinary();
    },
    ListZonesResponse.deserializeBinary
  );

  listZones(
    request: ListZonesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: ListZonesResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.MassiveDeliveryService/ListZones',
      request,
      metadata || {},
      this.methodInfoListZones,
      callback);
  }

  methodInfoUpdateVehicleOrder = new grpcWeb.AbstractClientBase.MethodInfo(
    UpdateVehicleOrderResponse,
    (request: UpdateVehicleOrderRequest) => {
      return request.serializeBinary();
    },
    UpdateVehicleOrderResponse.deserializeBinary
  );

  updateVehicleOrder(
    request: UpdateVehicleOrderRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: UpdateVehicleOrderResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.MassiveDeliveryService/UpdateVehicleOrder',
      request,
      metadata || {},
      this.methodInfoUpdateVehicleOrder,
      callback);
  }

}

export class FileServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials: null | { [index: string]: string; },
               options: null | { [index: string]: string; }) {
    if (!options) options = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoGetFileSignedUrl = new grpcWeb.AbstractClientBase.MethodInfo(
    GetFileSignedUrlResponse,
    (request: GetFileSignedUrlRequest) => {
      return request.serializeBinary();
    },
    GetFileSignedUrlResponse.deserializeBinary
  );

  getFileSignedUrl(
    request: GetFileSignedUrlRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetFileSignedUrlResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.FileService/GetFileSignedUrl',
      request,
      metadata || {},
      this.methodInfoGetFileSignedUrl,
      callback);
  }

}

export class CountryServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials: null | { [index: string]: string; },
               options: null | { [index: string]: string; }) {
    if (!options) options = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoListCountry = new grpcWeb.AbstractClientBase.MethodInfo(
    ListCountriesResponse,
    (request: ListCountriesRequest) => {
      return request.serializeBinary();
    },
    ListCountriesResponse.deserializeBinary
  );

  listCountry(
    request: ListCountriesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: ListCountriesResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.routing.proto.CountryService/ListCountry',
      request,
      metadata || {},
      this.methodInfoListCountry,
      callback);
  }

}

